import React from "react";
import { Box, Button } from "@mui/material";
import SaveOutlinedIcon from "@mui/icons-material/SaveOutlined";
import { Locale } from "../../assets/Locale";

import "./BlimpMuiFormActions.scss";

const getClassName = (...items)=>items.filter(Boolean).join(" ");

const renderAction = (action, index)=>{
    const {
        className,
        disabled,
        icon,
        key,
        label,
        onClick,
        primary,
        type="button",
        variant
    } = action;

    return (
        <Button
            className={getClassName(primary ? "BlimpMuiPanel-actionPrimary" : "BlimpMuiPanel-action", className)}
            disabled={disabled}
            key={key ?? index}
            onClick={onClick}
            startIcon={icon}
            type={type}
            variant={variant ?? (primary ? "contained" : "outlined")}
        >
            {label}
        </Button>
    );
};

export const BlimpMuiFormActions = (props)=>{
    const {
        actions,
        cancelLabel,
        className,
        onCancel,
        submitDisabled=false,
        submitIcon=<SaveOutlinedIcon />,
        submitLabel
    } = props;
    const say = Locale.use();
    const actionList = Array.isArray(actions) ? actions : [
        onCancel && {
            key:"cancel",
            label:cancelLabel ?? say("commonCancel"),
            onClick:onCancel
        },
        {
            key:"submit",
            disabled:submitDisabled,
            icon:submitIcon,
            label:submitLabel ?? say("commonSave"),
            primary:true,
            type:"submit"
        }
    ].filter(Boolean);

    return (
        <Box className={getClassName("BlimpMuiPanel-actions", className)}>
            {actionList.map(renderAction)}
        </Box>
    );
};
